<template>
  <li class="nav-item" v-for="(feature, key) in features.data" :key="key">
    <Link
      :href="route(`${routePrefix}.features.edit`, { id: feature.data.id })"
      :class="selectedFeature?.data.attributes.ucid === feature.data.attributes.ucid ? 'active' : 'text-muted'"
      class="nav-link"
    >
      <colored-icon
        v-if="feature.data.attributes.icon_class"
        :icon-class="feature.data.attributes.icon_class"
        :color="feature.data.attributes.icon_color"
        :shadow="false"
      ></colored-icon>
      {{ feature.data.attributes.name }}
    </Link>
  </li>
</template>

<script>
import ColoredIcon from "@kanrisha/components/Icons/ColoredIcon";
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    ColoredIcon,
    Link,
  },
  props: {
    features: { type: Object, default: () => {} },
    selectedFeature: { type: Object, default: () => {} },
  },
  setup(props) {

    return {

    }
  },
};
</script>